import { css } from 'lit';

export const styles = css`
  :host {
    display: block;
    width: 100%;
    height: 100%;
    flex: 1;
  }
  
  #calendar {
    height: 100% !important;
    width: 100% !important;
    min-height: 100%;
  }
  
  .fc-event {
    cursor: pointer;
  }
  
  .fc-event.overdue {
    background-color: #dc3545 !important;
    border-color: #dc3545 !important;
  }
  
  .fc-event.due-soon {
    background-color: #ffc107 !important;
    border-color: #ffc107 !important;
    color: #000 !important;
  }
  
  .fc-event.completed {
    background-color: #28a745 !important;
    border-color: #28a745 !important;
  }
  
  .fc-event-title {
    font-weight: 500;
  }
  
  .fc-toolbar {
    margin-bottom: 1rem;
  }
  
  .fc-button {
    background-color: var(--sl-color-primary-600);
    border-color: var(--sl-color-primary-600);
  }
  
  .fc-button:hover {
    background-color: var(--sl-color-primary-700);
    border-color: var(--sl-color-primary-700);
  }
  
  .fc-button:focus {
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
  
  .fc-today-button {
    background-color: var(--sl-color-neutral-600);
    border-color: var(--sl-color-neutral-600);
  }
  
  .fc-today-button:hover {
    background-color: var(--sl-color-neutral-700);
    border-color: var(--sl-color-neutral-700);
  }
`;
